import React, { forwardRef } from 'react';
import { ListItem as MuiListItem } from '@mui/material';
import { isEmpty } from 'lodash';

import { reportErrorInProductionOrThrow } from '~/Utils';

/**
 This Component is a wrapper on MUI component.
 This component should be imported and not MUI directly!
**/

/**
 * Explicit ListItem props based on actual usage in the codebase.
 */
export interface ListItemProps {
  /** If true, compact vertical padding is used */
  dense?: boolean;
  /** CSS class name to apply to the root element */
  className?: string;
  /** Inline styles applied to the root element */
  style?: React.CSSProperties;
  /** The component used for the root node (e.g. `"label"`) */
  component?: React.ElementType;
  /** The content of the list item */
  children?: React.ReactNode;
}

const ListItem = forwardRef<HTMLLIElement, ListItemProps>(
  ({ dense, className, style, component, children, ...restProps }, ref) => {
    if (!isEmpty(restProps)) {
      reportErrorInProductionOrThrow(
        `Unexpected props passed to ListItem: ${Object.keys(restProps).join(', ')}.
Examine if these need to be removed, or added explicitly to the ListItemProps interface and to the component's signature.`,
        true
      );
    }

    return (
      <MuiListItem {...{ dense, className, style, component }} ref={ref} {...restProps}>
        {children}
      </MuiListItem>
    );
  }
);

ListItem.displayName = 'ListItem';

export default ListItem;
